import { TableCell } from '@mui/material';
import { Whisper, Tooltip } from 'rsuite';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  removeMinusFromBalance,
  formatBalanceUi,
} from '@utils/balance-helpers';
import { currencySymbols } from '@utils/static';

export function TransactionChargedAmount({ row }) {
  return (
    <p>{formatBalanceUi(removeMinusFromBalance(row?.amount), row?.currency)}</p>
  );
}

export function getConversionRate(row) {
  const amount = Number(row?.amount);
  const originalAmount = Number(row?.original_amount);

  if (
    !Number.isFinite(amount) ||
    !Number.isFinite(originalAmount) ||
    originalAmount === 0
  ) {
    return '—';
  }

  return Math.abs(amount / originalAmount).toFixed(2);
}

export function getOperationFee(row, tariff) {
  const symbol = currencySymbols[row?.currency];

  const format = (value) => {
    const fee = Number(value);
    if (value === null || value === undefined || !Number.isFinite(fee)) {
      return '—';
    }
    return symbol ? `${fee} ${symbol}` : String(fee);
  };

  if (row?.order_status === 'Held' || row?.order_status === 'Accepted') {
    return format(tariff?.transaction_commission);
  }
  if (row?.order_status === 'Declined') {
    return format(tariff?.decline_transaction_commission);
  }
  return '—';
}

export default function TransactionChargedCell({ row }) {
  const { t } = useTranslation();
  const { tariff } = useSelector((state) => state.tariff);

  const comission = getOperationFee(row, tariff);

  return (
    <TableCell>
      <div className="balanceAmountCell">
        <Whisper
          placement="auto"
          controlId="control-id-hover"
          trigger="hover"
          speaker={
            <Tooltip className="balanceAmountCell__tooltip">
              <p>
                <span>{getConversionRate(row)}</span> {t('conversion_rate')}
              </p>
              <p>
                <span>{comission}</span> {t('operation_fee')}
              </p>
            </Tooltip>
          }
        >
          {/* todo: пофиксить цвет */}
          <button className={`dashed-btn positive`}>
            <TransactionChargedAmount row={row} />
          </button>
        </Whisper>
        <p className="secondary-text">
          {formatBalanceUi(row?.original_amount, row?.currency_original)}
        </p>
      </div>
    </TableCell>
  );
}
